import React from 'react';
import { View, Platform } from 'react-native';
import Svg, { Path, Circle, Rect, Line, Polyline, G } from 'react-native-svg';

// Only import Ionicons for native platforms as fallback
let Ionicons = null;
if (Platform.OS !== 'web') {
  Ionicons = require('@expo/vector-icons').Ionicons;
}

// SVG Icon paths for common icons
const iconPaths = {
  // Navigation icons
  'home': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M9 22V12h6v10', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'people': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 9, cy: 7, r: 4, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M23 21v-2a4 4 0 0 0-3-3.87', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M16 3.13a4 4 0 0 1 0 7.75', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'people-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 9, cy: 7, r: 4, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M23 21v-2a4 4 0 0 0-3-3.87', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M16 3.13a4 4 0 0 1 0 7.75', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'person': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2', fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 12, cy: 7, r: 4, fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'person-circle': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 12, cy: 12, r: 10, fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 12, cy: 8, r: 3, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M6.168 18.849A4 4 0 0 1 10 16h4a4 4 0 0 1 3.834 2.855', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'heart': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'sparkles': {
    viewBox: '0 0 24 24',
    paths: [
      // Main sparkle
      { d: 'M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3z', fill: 'none', stroke: true, strokeWidth: 2 },
      // Small sparkle top-right
      { d: 'M19 2l0.5 1.5L21 4l-1.5 0.5L19 6l-0.5-1.5L17 4l1.5-0.5L19 2z', fill: 'none', stroke: true, strokeWidth: 1.5 },
      // Small sparkle bottom-left
      { d: 'M6 16l0.5 1.5L8 18l-1.5 0.5L6 20l-0.5-1.5L4 18l1.5-0.5L6 16z', fill: 'none', stroke: true, strokeWidth: 1.5 }
    ]
  },
  'shield-checkmark': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M9 12l2 2 4-4', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'shield': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'git-network': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 6, cy: 6, r: 2, fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 18, cy: 6, r: 2, fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 12, cy: 18, r: 2, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M6 8v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M12 14v2', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'share-social': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 18, cy: 5, r: 3, fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 6, cy: 12, r: 3, fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 18, cy: 19, r: 3, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M8.59 13.51l6.83 3.98', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M15.41 6.51l-6.82 3.98', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'menu': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M3 12h18', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M3 6h18', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M3 18h18', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'close': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M18 6L6 18', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M6 6l12 12', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'search': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 11, cy: 11, r: 8, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M21 21l-4.35-4.35', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'arrow-back': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M19 12H5', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M12 19l-7-7 7-7', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'arrow-forward': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M5 12h14', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M12 5l7 7-7 7', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'download': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M7 10l5 5 5-5', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M12 15V3', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'checkmark': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M20 6L9 17l-5-5', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'checkmark-circle': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 12, cy: 12, r: 10, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M9 12l2 2 4-4', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'checkmark-circle-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 12, cy: 12, r: 10, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M9 12l2 2 4-4', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'chevron-down': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M6 9l6 6 6-6', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'chevron-back': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M15 18l-6-6 6-6', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'chevron-forward': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M9 18l6-6-6-6', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'checkmark-done': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M18 6L9 17l-5-5', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M22 10L13 21l-2-2', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'sync': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M23 4v6h-6', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M1 20v-6h6', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M3.51 9a9 9 0 0 1 14.85-3.36L23 10', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M20.49 15a9 9 0 0 1-14.85 3.36L1 14', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'repeat': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M17 1l4 4-4 4', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M3 11V9a4 4 0 0 1 4-4h14', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M7 23l-4-4 4-4', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M21 13v2a4 4 0 0 1-4 4H3', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'images': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'rect', x: 3, y: 3, width: 18, height: 18, rx: 2, fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 8.5, cy: 8.5, r: 1.5, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M21 15l-5-5L5 21', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'school': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M12 3L1 9l11 6 9-4.91V17h2V9L12 3z', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'information-circle': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 12, cy: 12, r: 10, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M12 16v-4', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M12 8h.01', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'bulb': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M9 18h6', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M10 22h4', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M12 2a7 7 0 0 0-4 12.73V17h8v-2.27A7 7 0 0 0 12 2z', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'chatbubbles': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'create': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'create-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'pencil': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'calendar-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'rect', x: 3, y: 4, width: 18, height: 18, rx: 2, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M16 2v4', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M8 2v4', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M3 10h18', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'school-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M12 3L1 9l11 6 9-4.91V17h2V9L12 3z', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'briefcase-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'rect', x: 2, y: 7, width: 20, height: 14, rx: 2, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'location-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z', fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 12, cy: 10, r: 3, fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'time-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 12, cy: 12, r: 10, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M12 6v6l4 2', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'hourglass-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M6 2h12v5l-6 5 6 5v5H6v-5l6-5-6-5V2z', fill: true, stroke: false }
    ]
  },
  'star': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z', fill: true, stroke: false }
    ]
  },
  'thumbs-up': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3', fill: true, stroke: false }
    ]
  },
  'thumbs-down': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17', fill: true, stroke: false }
    ]
  },
  'pause': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'rect', x: 6, y: 4, width: 4, height: 16, fill: true, stroke: false },
      { type: 'rect', x: 14, y: 4, width: 4, height: 16, fill: true, stroke: false }
    ]
  },
  'swap-horizontal': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M16 3l4 4-4 4', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M20 7H4', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M8 21l-4-4 4-4', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M4 17h16', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'log-out': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M16 17l5-5-5-5', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M21 12H9', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'add': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M12 5v14', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M5 12h14', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'remove': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M5 12h14', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'add-circle': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 12, cy: 12, r: 10, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M12 8v8', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M8 12h8', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'eye': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z', fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 12, cy: 12, r: 3, fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'eye-off': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M1 1l22 22', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'camera': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z', fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 12, cy: 13, r: 4, fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'trash': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M3 6h18', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'trash-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M3 6h18', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'settings': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 12, cy: 12, r: 3, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  // Outline variants
  'share-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 18, cy: 5, r: 3, fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 6, cy: 12, r: 3, fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 18, cy: 19, r: 3, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M8.59 13.51l6.83 3.98', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M15.41 6.51l-6.82 3.98', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'share-social-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 18, cy: 5, r: 3, fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 6, cy: 12, r: 3, fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 18, cy: 19, r: 3, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M8.59 13.51l6.83 3.98', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M15.41 6.51l-6.82 3.98', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'eye-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z', fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 12, cy: 12, r: 3, fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'search-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 11, cy: 11, r: 8, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M21 21l-4.35-4.35', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'options-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M4 21v-7', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M4 10V3', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M12 21v-9', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M12 8V3', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M20 21v-5', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M20 12V3', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M1 14h6', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M9 8h6', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M17 16h6', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'person-add-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 8.5, cy: 7, r: 4, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M20 8v6', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M23 11h-6', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'funnel-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M22 3H2l8 9.46V19l4 2v-8.54L22 3z', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'filter-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M22 3H2l8 9.46V19l4 2v-8.54L22 3z', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'swap-vertical-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M7 3v18', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M3 7l4-4 4 4', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M17 21V3', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M21 17l-4 4-4-4', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'chevron-up': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M18 15l-6-6-6 6', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'close-circle': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 12, cy: 12, r: 10, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M15 9l-6 6', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M9 9l6 6', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'alert-circle': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 12, cy: 12, r: 10, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M12 8v4', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M12 16h.01', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'mail': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M22 6l-10 7L2 6', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'mail-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M22 6l-10 7L2 6', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'call': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'call-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'people-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 9, cy: 7, r: 4, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M23 21v-2a4 4 0 0 0-3-3.87', fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M16 3.13a4 4 0 0 1 0 7.75', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'person-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { d: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2', fill: 'none', stroke: true, strokeWidth: 2 },
      { type: 'circle', cx: 12, cy: 7, r: 4, fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'lock-closed': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'rect', x: 3, y: 11, width: 18, height: 11, rx: 2, ry: 2, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M7 11V7a5 5 0 0 1 10 0v4', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'lock-closed-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'rect', x: 3, y: 11, width: 18, height: 11, rx: 2, ry: 2, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M7 11V7a5 5 0 0 1 10 0v4', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'key': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 7, cy: 17, r: 4, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M10.1 14.9l9.9-9.9M16 4h5v5M16 9l2-2', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  },
  'key-outline': {
    viewBox: '0 0 24 24',
    paths: [
      { type: 'circle', cx: 7, cy: 17, r: 4, fill: 'none', stroke: true, strokeWidth: 2 },
      { d: 'M10.1 14.9l9.9-9.9M16 4h5v5M16 9l2-2', fill: 'none', stroke: true, strokeWidth: 2 }
    ]
  }
};

// Render a single path element based on type
const renderPathElement = (item, index, color) => {
  const strokeColor = item.stroke ? color : 'none';
  const fillColor = item.fill === 'none' ? 'none' : color;
  
  if (item.type === 'circle') {
    return (
      <Circle
        key={index}
        cx={item.cx}
        cy={item.cy}
        r={item.r}
        stroke={strokeColor}
        strokeWidth={item.strokeWidth || 2}
        fill={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    );
  } else if (item.type === 'rect') {
    return (
      <Rect
        key={index}
        x={item.x}
        y={item.y}
        width={item.width}
        height={item.height}
        rx={item.rx || 0}
        stroke={strokeColor}
        strokeWidth={item.strokeWidth || 2}
        fill={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    );
  } else {
    return (
      <Path
        key={index}
        d={item.d}
        stroke={strokeColor}
        strokeWidth={item.strokeWidth || 2}
        fill={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    );
  }
};

// Main SVG Icon component - drop-in replacement for Ionicons
// Uses SVG on web for reliability, falls back to Ionicons on native if icon not found
export default function SvgIcon({ name, size = 24, color = '#000', style }) {
  const iconData = iconPaths[name];
  
  // On native platforms, use Ionicons as fallback for any icon not in our SVG set
  if (!iconData && Platform.OS !== 'web' && Ionicons) {
    return <Ionicons name={name} size={size} color={color} style={style} />;
  }
  
  if (!iconData) {
    // Fallback: render a simple placeholder for unknown icons on web
    console.warn(`SvgIcon: Unknown icon "${name}"`);
    return (
      <View style={[{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }, style]}>
        <Svg width={size} height={size} viewBox="0 0 24 24">
          <Circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" fill="none" />
          <Path d="M12 8v4M12 16h.01" stroke={color} strokeWidth="2" strokeLinecap="round" />
        </Svg>
      </View>
    );
  }

  return (
    <View style={[{ width: size, height: size }, style]}>
      <Svg width={size} height={size} viewBox={iconData.viewBox}>
        {iconData.paths.map((pathItem, index) => renderPathElement(pathItem, index, color))}
      </Svg>
    </View>
  );
}

// Export for use as named import as well
export { SvgIcon };
